<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.step3_terrace.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.project.step3_terrace.title') }}</h1>
        <save />
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="form" class="std-form">

          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label">
                {{ Translator('soprasolar.project.step3_terrace.form.sealing_type.label') }}
              </label>
            </div>

            <div class="radios">
              <div class="radio">
                <input class="radio-input" @change="onChangeSealing" type="radio" id="sealing_type_bitumen" name="sealing_type" v-model="form.sealing_type" value="bitumen">
                <label class="radio-label" for="sealing_type_bitumen">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.sealing_type.bitumen') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" @change="onChangeSealing" type="radio" id="sealing_type_pvc" name="sealing_type" v-model="form.sealing_type" value="pvc">
                <label class="radio-label" for="sealing_type_pvc">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.sealing_type.pvc') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" @change="onChangeSealing" type="radio" id="sealing_type_tpo" name="sealing_type" v-model="form.sealing_type" value="tpo">
                <label class="radio-label" for="sealing_type_tpo">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.sealing_type.tpo') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" @change="onChangeSealing" type="radio" id="sealing_type_dontknow" name="sealing_type" v-model="form.sealing_type" value="dontknow">
                <label class="radio-label" for="sealing_type_dontknow">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.sealing_type.dontknow') }}</p>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label">
                {{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.label') }}
              </label>
            </div>

            <div class="radios">
              <div class="radio" v-if="datas.step2.classification !== 'icpe' || form.sealing_type === 'bitumen' || form.sealing_type === 'dontknow' || (datas.step2.classification === 'icpe' && (form.sealing_type === 'pvc' || form.sealing_type === 'tpo'))">
                <input class="radio-input" @change="onChangePhotovoltaic" type="radio" id="photovoltaic_process_evo" name="photovoltaic_process" v-model="form.photovoltaic_process" value="evo">
                <label class="radio-label" for="photovoltaic_process_evo">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.evo') }}</p>
                  <div class="radio-label-media">
                    <img src="/assets/soprasolar/images/project/type-evo.png" alt="">
                  </div>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" @change="onChangePhotovoltaic" type="radio" id="photovoltaic_process_evo_tilt" name="photovoltaic_process" v-model="form.photovoltaic_process" value="evo_tilt">
                <label class="radio-label" for="photovoltaic_process_evo_tilt">
                  <p class="radio-label-text">
                    {{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.evo_tilt') }}
                    <span>{{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.evo_tilt_more') }}</span>
                  </p>
                  <div class="radio-label-media">
                    <img src="/assets/soprasolar/images/project/type-evo-tilt-s.png" alt="">
                  </div>
                </label>
              </div>
              <div class="radio" v-if="form.sealing_type !== 'pvc'">
                <input class="radio-input" @change="onChangePhotovoltaic" type="radio" id="photovoltaic_process_light_reflection" name="photovoltaic_process" v-model="form.photovoltaic_process" value="light_reflection">
                <label class="radio-label" for="photovoltaic_process_light_reflection">
                  <p class="radio-label-text">
                    {{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.light_reflection') }}
                    <span>{{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.light_reflection_more') }}</span>
                  </p>
                  <div class="radio-label-media">
                    <img src="/assets/soprasolar/images/project/type-light_reflection.png" alt="">
                  </div>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" @change="onChangePhotovoltaic" type="radio" id="photovoltaic_process_dontknow" name="photovoltaic_process" v-model="form.photovoltaic_process" value="dontknow">
                <label class="radio-label" for="photovoltaic_process_dontknow">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.dontknow') }}</p>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group" v-if="form.photovoltaic_process === 'evo_tilt'">
            <div class="form-label-container">
              <label for="coefficient" class="control-label">
                {{ Translator('soprasolar.project.step3_terrace.form.orientation.label') }}
              </label>
            </div>

            <div class="radios">
              <div class="radio">
                <input class="radio-input" type="radio" id="orientation_est_ouest" name="orientation" v-model="form.orientation" value="est/ouest">
                <label class="radio-label" for="orientation_est_ouest">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.orientation.est/ouest') }}</p>
                  <div class="radio-label-media">
                    <img src="/assets/soprasolar/images/project/type-evo-tilt-eo.png" alt="">
                  </div>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" type="radio" id="orientation_sud" name="orientation" v-model="form.orientation" value="sud">
                <label class="radio-label" for="orientation_sud">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.orientation.sud') }}</p>
                  <div class="radio-label-media">
                    <img src="/assets/soprasolar/images/project/type-evo-tilt-s.png" alt="">
                  </div>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" type="radio" id="orientation_dontknow" name="orientation" v-model="form.orientation" value="dontknow">
                <label class="radio-label" for="orientation_dontknow">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_terrace.form.orientation.dontknow') }}</p>
                </label>
              </div>
            </div>
          </div>


        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="form" :disabled="isLoading">
          {{ Translator('soprasolar.project.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.project.required_field') }}</p>
  </div>
</template>
<script>
import FormControl from 'aw-front-helpers/classes/formControl';
import AppControlService from '@/soprasolar-project/services/AppControl';
import Save from '@/soprasolar-project/components/Save';

export default {
  name: 'step-3-terrace',
  components: {
    Save
  },
  data () {
    return {
      datas: AppControlService.datas,
      isLoading: false,
      form: {}
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step3) this.form = this.datas.step3;
  },
  methods: {
    onChangeSealing() {
      delete this.form.photovoltaic_process;
      delete this.form.orientation;
    },

    onChangePhotovoltaic() {
      delete this.form.orientation;
    },

    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._form.isValidate) {
        if(this.isLoading) return;
        this.isLoading = true;
        AppControlService.update('step3', this.form).then( () => {
          AppControlService.goToNextStep();
        }).catch(console.error).then(() => {
          this.isLoading = false;
        })
      }
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step3) this.form = this.datas.step3;
    }
  }
};
</script>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
.project-wrapper {
  @include vertical-spacing-inner-top;
}
</style>